/**
 * The bounds the API holds a journey type and a journey to. The consoles pass
 * the same object to the forms, so a field says what is wrong before anything
 * is sent. A timing setting beyond a year is a typo, not a plan.
 */
export const JOURNEY_LIMITS = {
  name: 200,
  goal: 4000,
  steps: 24,
  /* Ten years after the start, in each unit a step can be counted in. */
  offsetAmount: { days: 3650, weeks: 520, months: 120 },
  days: 365,
  maxRepeats: 10,
} as const;

/** Spec 4's timing: what a new journey type starts from. */
export const JOURNEY_TYPE_DEFAULT_TIMING = {
  margin_days: 14,
  pre_warning_days: 10,
  repeat_interval_days: 7,
  max_repeats: 3,
} as const;
